import { Skeleton } from "@mui/material"
import React, { useEffect } from "react"

import { PriceDisplay } from "./PriceDisplay"
import { useTokenPrices } from "@/api/portfolio-api"
import { getTotalSupplyToken } from "@/api/token-api"

import type { PoolOverview } from "@/types"
import { sortPoolAssets } from "@/utils/flipper"

export default function MarketCapDisplay({ pool }: { pool: PoolOverview }) {
  const [isLoading, setIsLoading] = React.useState(false)
  const [totalSupply, setTotalSupply] = React.useState<number | null>(null)

  const sortedTokens = sortPoolAssets({
    token0: pool.token0,
    token1: pool.token1,
    token0Ticker: pool.token0Ticker,
    token1Ticker: pool.token1Ticker,
  })

  const token = sortedTokens.base
  const denom = sortedTokens.base === pool.token0 ? pool.token0Denominator : pool.token1Denominator

  const [prices] = useTokenPrices()
  const tokenPrice = prices?.[token] ? prices[token].price || null : null

  //dummy
  useEffect(() => {
    setIsLoading(true)
    getTotalSupplyToken(token)
      .then((res) => {
        setTotalSupply(Number(res))
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [token])

  if (isLoading || !totalSupply) return <Skeleton sx={{ display: "inline-block" }} width={60} />

  const ts = totalSupply / 10 ** denom
  const marketCap = ts * (tokenPrice || 0)

  return <PriceDisplay amount={marketCap} />
}
